import React from 'react'
import './weight.css'
const GetFit = () => {
  return (
    <div id='Fit'>
      <i id='colo' className="fa-solid fa-quote-right fa-5x"></i>
        <h4>Get Fit in the gym,
        <br />
        lose weight in the Kitchen.</h4>

    </div>
  )
}

export default GetFit
